import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type DealerDisclaimersConfiguratorDataFragment = (
  { __typename: 'DealerDisclaimersConfigurator' }
  & { defaultValue: Array<SchemaTypes.Maybe<(
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  )>>, overrides: Array<(
    { __typename: 'DealerDisclaimersOverridesConfigurator' }
    & Pick<SchemaTypes.DealerDisclaimersOverridesConfigurator, 'dealerId'>
    & { value: Array<(
      { __typename: 'TranslatedString' }
      & TranslatedStringDataFragment
    )> }
  )> }
);

export const DealerDisclaimersConfiguratorDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerDisclaimersConfiguratorData on DealerDisclaimersConfigurator {
  defaultValue {
    ...TranslatedStringData
  }
  overrides {
    dealerId
    value {
      ...TranslatedStringData
    }
  }
}
    `;